import "./chartcard.css";
import { useState } from "react";

const data6M = [
  { month: "Jan", value1: 8, value2: 5 },
  { month: "Feb", value1: 12, value2: 8 },
  { month: "Mar", value1: 15, value2: 11 },
  { month: "Apr", value1: 18, value2: 14 },
  { month: "May", value1: 22, value2: 16 },
  { month: "Jun", value1: 24, value2: 18 },
];

const data1Y = [
  ...data6M,
  { month: "Jul", value1: 26, value2: 20 },
  { month: "Aug", value1: 28, value2: 22 },
  { month: "Sep", value1: 30, value2: 24 },
  { month: "Oct", value1: 32, value2: 26 },
  { month: "Nov", value1: 34, value2: 28 },
  { month: "Dec", value1: 36, value2: 30 },
];

export default function ChartCard() {
  const [activeTab, setActiveTab] = useState("6M");

  const chartData = activeTab === "6M" ? data6M : data1Y;

  const maxValue = 40; // for scaling

  const generatePoints = (key) =>
    chartData
      .map((item, index) => {
        const x = (index / (chartData.length - 1)) * 300;
        const y = 160 - (item[key] / maxValue) * 140;
        return `${x},${y}`;
      })
      .join(" ");

  return (
    <div className="rp-chartcard-card">
      <div className="rp-chartcard-header">
        <h4>Lead Performance</h4>

        <div className="rp-chartcard-tabs">
          <span
            className={activeTab === "6M" ? "active" : ""}
            onClick={() => setActiveTab("6M")}
          >
            6M
          </span>
          <span
            className={activeTab === "1Y" ? "active" : ""}
            onClick={() => setActiveTab("1Y")}
          >
            1Y
          </span>
        </div>
      </div>

      <div className="rp-chartcard-body">
        <div className="rp-chartcard-yaxis">
          <span>40</span>
          <span>30</span>
          <span>20</span>
          <span>10</span>
          <span>0</span>
        </div>

        <div className="rp-chartcard-chart">
          <svg viewBox="0 0 300 160" preserveAspectRatio="none">
            {/* Grid */}
            {[0, 30, 60, 90, 120, 150].map((y, i) => (
              <line
                key={i}
                x1="0"
                y1={y}
                x2="300"
                y2={y}
                className="grid"
              />
            ))}

            {/* Lines */}
            <polyline
              points={generatePoints("value1")}
              fill="none"
              stroke="#21c098"
              strokeWidth="3"
              strokeLinecap="round"
            />

            <polyline
              points={generatePoints("value2")}
              fill="none"
              stroke="#8ee0c7"
              strokeWidth="3"
              strokeLinecap="round"
            />
          </svg>

          {/* Dots */}
          {chartData.map((item, index) => {
            const left = (index / (chartData.length - 1)) * 100;
            const top1 = 100 - (item.value1 / maxValue) * 88;
            const top2 = 100 - (item.value2 / maxValue) * 88;

            return (
              <div key={index}>
                <span
                  className="rp-chartcard-dot dark"
                  style={{ left: `${left}%`, top: `${top1}%` }}
                />
                <span
                  className="rp-chartcard-dot light"
                  style={{ left: `${left}%`, top: `${top2}%` }}
                />
              </div>
            );
          })}
        </div>
      </div>

      <div className="rp-chartcard-xaxis">
        {chartData.map((item, i) => (
          <span key={i}>{item.month}</span>
        ))}
      </div>
    </div>
  );
}
